/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Nav_DownloadInputs */

const en_pc_nav_download = /** @type {(inputs: Pc_Nav_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const zh_pc_nav_download = /** @type {(inputs: Pc_Nav_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Pc_Nav_DownloadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_nav_download = /** @type {((inputs?: Pc_Nav_DownloadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Nav_DownloadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_nav_download(inputs)
	return zh_pc_nav_download(inputs)
});
export { pc_nav_download as "pc.nav.download" }